import React from 'react';

import { getIn } from '@gogame/form';

import { useGroup } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Group';

import { PlanStateContext } from '../PlanStateContext';

export const usePlanStateField = name => {
  const {
    state,
    api: { onChangeField },
  } = React.useContext(PlanStateContext);
  const { getResolveName, levelPath } = useGroup();
  const resolvedName = getResolveName(name);
  const value = getIn(state, resolvedName);
  const handleChange = (_e, value = 0) => {
    onChangeField({ name: resolvedName, value, levelPath });
  };
  return { value, onChange: handleChange, resolvedName };
};
